import React from 'react';
import { Button, Divider, Group, Pill, Stack, Text } from '@mantine/core';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import { BaseCommentWithMentionsAndUser } from '@/common/types/databaseTypes';
import { useTranslation } from 'react-i18next';

interface ReplySectionProps {
    comment: BaseCommentWithMentionsAndUser;
    isCollapsed: boolean;
    onToggle: () => void;
    children: React.ReactNode;
}

export const ReplySection: React.FC<ReplySectionProps> = ({
    comment,
    isCollapsed,
    onToggle,
    children,
}) => {
    const { t } = useTranslation('comment');
    const replyCount = comment.children?.length || 0;

    if (replyCount === 0) return null;

    return (
        <Stack gap="xs" ml={8}>
            <Stack gap={0}>
                <Divider size="xs" my="sm" />
                <Group gap={2}>
                    <Pill size="xs" c="dimmed" px={4}>
                        <Text fz={12} fw={500}>
                            {replyCount}
                        </Text>
                    </Pill>
                    <Button
                        variant="transparent"
                        size="compact-xs"
                        color="black"
                        rightSection={
                            isCollapsed ? (
                                <IconChevronDown size={14} color="gray" />
                            ) : (
                                <IconChevronUp size={14} color="gray" />
                            )
                        }
                        styles={{
                            section: { marginLeft: 4 },
                        }}
                        onClick={onToggle}
                    >
                        {t('reply.title')}
                    </Button>
                </Group>
            </Stack>
            {!isCollapsed && children}
        </Stack>
    );
};
